import axios from 'axios';
import { isTokenExpired, clearAuthData } from './authHelper';

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API + import.meta.env.VITE_APP_API_VERSION,
  withCredentials: true,
});

// Helper function to handle authentication failure
const handleAuthFailure = () => {
  console.log('Authentication failed or token expired. Redirecting to login.');
  clearAuthData();
  window.location.href = '/login';
};

// Add request interceptor to add token and check expiration
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      // Check if token is expired before making request
      if (isTokenExpired()) {
        handleAuthFailure();
        return Promise.reject(new Error('Token expired'));
      }
      
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration and auth errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      console.error('401 Unauthorized:', error.response.data?.message || 'Authentication failed');
      handleAuthFailure();
    } else if (error.response?.status === 403) {
      console.error('403 Forbidden:', error.response.data?.message || 'Access denied');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 